import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators
} from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef
} from '@angular/material/dialog';
import { SiteModel } from 'src/app/models/index';
import {
  CommonService,
  LoadService,
  SiteService,
  UserManagementService
} from 'src/app/services/index';
import { AlertService } from 'src/app/shared';
import { AddUserSuccessModalComponent } from '../../add/add-user/add-user-success-modal/add-user-success-modal.component';
import { FeatureSelectionModalComponent } from '../feature-selection-modal/feature-selection-modal.component';
import { SsoLoginModalComponent } from '../sso-login-modal/sso-login-modal.component';

@Component({
  selector: 'app-add-edit-user-modal',
  templateUrl: './add-edit-user-modal.component.html',
  styleUrls: ['./add-edit-user-modal.component.scss']
})
export class AddEditUserModalComponent implements OnInit {
  formData: UntypedFormGroup;
  sites: any;
  roles: any;
  selected: SiteModel;
  user = {
    emailRecipientClass: 'To',
    email: '',
    userId: '',
    ntId: '',
    role: {},
    sites: [],
    activities: [],
    useSSO: false
  };

  error = {
    role: '',
    validation: undefined,
    message: ''
  };
  errMsg = '';
  maxSiteUserPerSite = 0;
  emailRecipientClass = ['To', 'Cc', 'Bcc', 'None'];
  firstNamePattern = '^([^0-9]*)$';
  typed = false;
  validation = undefined;
  MULTIPLE_SITE = false;
  SINGLE_SITE = false;
  ID_label = this.user.useSSO ? 'SSO ID' : 'Application ID';
  isSelected = false;
  tittle = '';
  countSelected = 0;
  selectedFeatures: any;
  allowShowAddFeatureButton = false;
  isEditMode = false;
  selectedSiteIds = [];
  add_eidt_label = 'Add User';
  constructor(
    private dialogRef: MatDialogRef<AddEditUserModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,

    private dialog: MatDialog,
    private alertService: AlertService,
    private siteService: SiteService,
    private commonService: CommonService,
    private userManagementService: UserManagementService,
    private cdRef: ChangeDetectorRef,
    private loadService: LoadService,
    private fb: UntypedFormBuilder
  ) {}

  ngOnInit() {
    this.formData = this.fb.group({
      projectCtr: ['', [Validators.required]],
      emailCtr: ['', [Validators.required, Validators.email]],
      roleCtr: [''],
      ntIDCtr: ['', [Validators.required]]
    });
    this.reset();
    this.loadData();
    if (this.data !== null && this.data.user !== null) {
      this.user.ntId = this.data.user.ntId;
      this.user.email = this.data.user.username;
      this.user.useSSO = this.data.user.useSSO;
      this.user.userId = this.data.user.userId;
      this.user.sites = this.data.user.sites;
      this.user.sites.forEach((site) => this.selectedSiteIds.push(site.siteId));
      this.tittle = 'Edit User';
      this.add_eidt_label = 'Edit User';
      this.isEditMode = true;
    } else {
      this.isSelected = true;
      this.tittle = 'Add New User';
      this.add_eidt_label = 'Add User';
    }
  }
  close(confirm: boolean) {
    this.dialogRef.close({ status: confirm, data: this.user });
  }
  loadData() {
    const t = this;

    t.sites = this.data.sites.map((site) => {
      return {
        siteId: site.SiteId,
        siteName: site.SiteName
      };
    });
    t.userManagementService.getMaxSiteUserPerSite().subscribe((data) => {
      if (data) {
        t.maxSiteUserPerSite = data.data;
      }
    });

    t.userManagementService.getSelectableRoles().subscribe((data) => {
      if (data && data.data.length > 0) {
        t.roles = data.data;
        if (!this.isNullOrUndefined(t.data.user)) {
          t.user.role = t.roles.find((c) => c.roleId === t.data.user.roleId);
          t.roleChange(t.user.role);
        }
      }
    });
    if (!this.isNullOrUndefined(this.data.user)) {
      t.userManagementService
        .getActivitiesOfUser(this.data.user.ntId)
        .subscribe((data) => {
          if (data && data.data.length > 0) {
            this.user.activities = data.data;
            this.countSelected = data.data.length;
          }
        });
    }
  }
  reset() {
    this.user = {
      emailRecipientClass: 'To',
      email: '',
      userId: '',
      ntId: '',
      role: {},
      sites: [],
      activities: [],
      useSSO: false
    };
    this.selectedSiteIds = [];
  }
  save() {
    const t = this;
    if (this.formData.valid && this.validateForm()) {
      t.user.useSSO = true;
      if (this.isEditMode) {
        t.userManagementService.updateUser(t.user).subscribe((data) => {
          if (data.code !== 200) {
            t.alertService.showError(data.message);
          } else {
            t.user = data.data;
            t.openModal();
          }
        });
      } else {
        t.userManagementService.addUser(t.user).subscribe((data) => {
          if (data.code !== 200) {
            t.alertService.showError(data.message);
          } else {
            t.user = data.data;
            t.openModal();
          }
        });
      }
    }
  }

  openModal() {
    const t = this;
    const dialogRef = this.dialog.open(AddUserSuccessModalComponent, {
      width: '800px'
    });
    dialogRef.componentInstance.user = t.user;

    dialogRef.afterClosed().subscribe((result) => {
      if (result.status === true) {
        this.close(true);
      }
    });
  }
  showSSOLoginModal() {
    const t = this;
    const dialogRef = this.dialog.open(SsoLoginModalComponent, {
      width: '600px'
    });
    dialogRef.componentInstance.ntID = this.user.ntId;

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        t.validation = result.data.data;
        t.errMsg = result.data.message;
        t.error.validation = result.data.data;
        t.error.message = result.data.message;
      }
    });
  }
  showFeaturePopup() {
    const t = this;
    const dialogRef = this.dialog.open(FeatureSelectionModalComponent, {
      width: '1000px'
    });
    dialogRef.componentInstance.user = t.user;

    dialogRef.afterClosed().subscribe((result) => {
      if (result.status === true && result.data) {
        this.countSelected = result.data.countSelected;
        if (
          !this.commonService.isNullOrUndefined(result.data.selectedFeatures) &&
          result.data.selectedFeatures.length > 0
        ) {
          this.selectedFeatures = result.data.selectedFeatures;
          this.user.activities = result.data.selectedFeatures;
        }
      }
    });
  }
  validateForm() {
    let result = true;

    if (
      !this.commonService.isNullOrUndefined(this.user.sites) &&
      this.user.sites.length > 0
    ) {
      this.user.sites.forEach((site) => {
        if (
          !this.commonService.isNullOrUndefined(site) &&
          !this.commonService.isNullOrUndefined(site.siteUsers) &&
          site.siteUsers.length >= this.maxSiteUserPerSite
        ) {
          this.error.role =
            'This site has exceeded ' +
            this.maxSiteUserPerSite +
            'users, cannot add more.';
          result = false;
        }
      });
    }
    return result;
  }
  public isFieldHasError = (fieldName: string, errorCode: string): boolean => {
    return this.formData.get(fieldName).hasError(errorCode);
  };
  emailRecipientClassChange(type) {
    this.user.emailRecipientClass = type;
  }

  roleChange(role) {
    if (
      this.commonService.isNullOrUndefined(role) ||
      this.commonService.isNullOrUndefined(role.siteSelectionType)
    ) {
      return;
    }
    switch (role.siteSelectionType) {
      case 'MULTIPLE':
        this.MULTIPLE_SITE = true;
        this.SINGLE_SITE = false;

        break;
      case 'SINGLE':
      default:
        this.MULTIPLE_SITE = false;
        this.SINGLE_SITE = true;
        break;
    }
    this.AddFeatureValidation(role);
  }

  AddFeatureValidation(role) {
    switch (role.siteSelectionType) {
      case 'MULTIPLE':
        this.allowShowAddFeatureButton = true;
        break;
      case 'SINGLE':
        this.allowShowAddFeatureButton = true;
        break;
      default:
        this.allowShowAddFeatureButton = false;
        break;
    }
  }
  siteChange(event) {
    // const role: any = this.user.role;
    if (this.SINGLE_SITE) {
      const siteId = event.value;
      const site = this.sites.find((c) => c.siteId === siteId);
      this.user.sites.push(site);
    } else {
      const findSites = event.value;
      if (
        !this.commonService.isNullOrUndefined(findSites) &&
        findSites.length > 0
      ) {
        this.user.sites = this.sites.filter((c) =>
          findSites.includes(c.siteId)
        );
      }
    }
  }
  changeUserType(evt) {
    if (evt.value === 'SSO') {
      this.user.useSSO = true;
    } else {
      this.user.useSSO = false;
      this.user.ntId = '';
    }
    this.validation = undefined;
    this.errMsg = '';
    this.error.validation = undefined;
    this.error.message = '';
    this.ID_label = this.user.useSSO ? 'SSO ID' : 'Application ID';
  }
  validate() {
    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    if (currentUser && !currentUser.useSSO) {
      this.showSSOLoginModal();
    } else {
      const param = {
        ntUsername: '',
        ntPassword: '',
        ntIDToCheck: this.user.ntId,
        rememberMe: 'false'
      };
      this.userManagementService.ValidateNTID(param).subscribe((data) => {
        if (data) {
          this.validation = data.data;
        }
      });
    }
  }
  isNullOrUndefined(x) {
    if (x == null) {
      return true;
    }

    if (x === null) {
      return true;
    }

    if (typeof x === 'undefined') {
      return true;
    }
    return false;
  }
}
